const campaignTracking = () => {
  window.addEventListener('message', (event) => {
    if (event.data) {
      try {
        const data = JSON.parse(event.data)
        const { action, name, campaign } = data
        if (action && name && campaign) {
          window.dataLayer.push({
            event: campaign,
            campaignType: action,
            eventName: name
          })
        }
      } catch (e) {
        /*eslint-disable */
        console.log(e)
        /* eslint-enable */
      }
    }
  }, false)
}

export default campaignTracking
